module.exports = "<a target=_blank :href=downloadURL>{{ dataset.title }}</a>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/tables/cells/link.vue
// module id = 473
// module chunks = 0